module.exports = __webpack_public_path__ + "img/teamwork-gradient-1930x1300.c33c7c18.jpg";